@if (user) {
    <form [formGroup]="editUserForm">
        <div class="inputGroup">
            <span class="label">{{ 'users.shijiUsers.edit.basic.email' | translate }}</span>
            <div class="inputWrapper">
                <app-form-error [parentForm]="editUserForm" [controlPath]="'email'" />
                <input type="email" id="email" disabled [value]="user.email" />
            </div>
        </div>
        <div class="inputGroup">
            <label for="firstName">{{ 'users.shijiUsers.edit.basic.firstName' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error [parentForm]="editUserForm" [controlPath]="'firstName'" />
                <input type="text" id="firstName" formControlName="firstName" trimInput />
            </div>
        </div>
        <div class="inputGroup">
            <label for="lastName">{{ 'users.shijiUsers.edit.basic.lastName' | translate }}</label>
            <div class="inputWrapper">
                <app-form-error [parentForm]="editUserForm" [controlPath]="'lastName'" />
                <input type="text" id="lastName" formControlName="lastName" trimInput />
            </div>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.shijiUsers.edit.basic.status' | translate }}</span>
            <span>{{ user.status }}</span>
        </div>
        <div class="inputGroup">
            <label for="doNotEmail" class="label">{{ 'users.shijiUsers.edit.basic.doNotEmail' | translate }}</label>
            <input type="checkbox" id="doNotEmail" formControlName="doNotEmail" />
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.shijiUsers.edit.basic.lastLogin' | translate }}</span>
            <span>{{ user.lastLogin | date: 'MMMM d, yyyy HH:mm' }}</span>
        </div>
        @if (notifications && notifications.length !== 0) {
            <div class="inputGroup labelTop">
                <span class="label">{{ 'users.supplierUsers.edit.basic.notificationControl' | translate }}</span>
                <div class="checkboxWrapper rows">
                    @for (notification of notifications; track notification) {
                        <div class="notificationWrapper" [formGroupName]="'notificationSettings'" id="notificationSettings">
                            <input type="checkbox" id="{{ notification.id }}" [formControlName]="notification.id" />
                            <label class="noFixedWidth noDisplaySet" for="{{ notification.id }}">
                                {{ 'myUserProfile.notifications.' + notification.notificationType | translate }}
                            </label>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="inputGroup">
            <label for="isEnabled">{{ 'users.shijiUsers.edit.basic.enabled' | translate }}</label>
            <input type="checkbox" id="isEnabled" formControlName="isEnabled" />
        </div>
        <div class="inputGroup">
            <label for="passwordChangeRequired">{{ 'users.shijiUsers.edit.basic.requirePasswordChange' | translate }}</label>
            <input type="checkbox" id="passwordChangeRequired" formControlName="passwordChangeRequired" />
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.shijiUsers.edit.basic.createdBy' | translate }}</span>
            <span class="underline">{{
                user.entityTracking.createdBy ? user.entityTracking.createdBy : ('users.userUnavailable' | translate)
            }}</span>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.shijiUsers.edit.basic.createdOn' | translate }}</span>
            <span>{{ user.entityTracking.createdAt | date: 'MMMM d, yyyy HH:mm' }}</span>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.shijiUsers.edit.basic.modifiedBy' | translate }}</span>
            <span class="underline">{{
                user.entityTracking.modifiedBy ? user.entityTracking.modifiedBy : ('users.userUnavailable' | translate)
            }}</span>
        </div>
        <div class="inputGroup">
            <span class="label">{{ 'users.shijiUsers.edit.basic.modifiedOn' | translate }}</span>
            <span>{{ user.entityTracking.modifiedAt | date: 'MMMM d, yyyy HH:mm' }}</span>
        </div>
    </form>
}
